import * as React from 'react';
import { useState } from 'react';
import { Grid, styled } from '@mui/material';
import { ErrorText, PrimaryButton } from 'library';
import { useHistory } from 'react-router';
import { loginUser } from '../login/LoginMethod';
import { useUserContext } from 'UserContext';
import { Link } from 'react-router-dom';
import { EmailInput, PasswordInput, Colors } from 'library';
import SignUpLoginTab from './SignUpLoginTab';
import SignUpLoginHeader from './SignUpLoginHeader';
import SignUpLoginContainer from './SignUpLoginContainer';
import theme from 'theme';

export default function LoginPage() {
    const history = useHistory();
    const { refreshUser } = useUserContext();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isUsernameError, setIsUsernameError] = useState(false);
    const [isPasswordError, setIsPasswordError] = useState(false);
    const [isValidError, setIsValidError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    function handleLogin() {
        setIsLoading(true);
        loginUser(
            username,
            password,
            refreshUser,
            history,
            setIsUsernameError,
            setIsPasswordError,
            setIsValidError,
            () => setIsLoading(false),
        );
    }

    return (
        <SignUpLoginContainer>
            <FormContainer item sm={12} md={6}>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleLogin();
                    }}
                >
                    <Grid container justifyContent="center">
                        <SignUpLoginTab />
                    </Grid>
                    <Content container>
                        <SignUpLoginHeader>Login to the Childcare Program Portal</SignUpLoginHeader>
                        <Grid container item direction="column" spacing={2}>
                            <Grid container item>
                                <EmailInput
                                    error={isUsernameError}
                                    errorText={'Please enter your email'}
                                    label="Email"
                                    id="login-email"
                                    value={username}
                                    onChange={(e) => setUsername(e)}
                                />
                            </Grid>
                            <Grid container item direction="column">
                                <PasswordInput
                                    id="login-password"
                                    error={isPasswordError}
                                    errorText={
                                        'Password must be minimum 8 characters with at least one uppercase letter, one lowercase letter, one digit, and one special character.'
                                    }
                                    value={password}
                                    label="Password"
                                    onChange={(e) => setPassword(e)}
                                    hideRequirements
                                />
                            </Grid>
                        </Grid>
                        {isValidError && <ErrorText>Either your username and password is incorrect</ErrorText>}

                        <Grid item xs={12} style={{ marginTop: 24, marginBottom: 15 }}>
                            <PrimaryButton
                                id="login-submit-button"
                                type="submit"
                                buttonStyle={{ width: 'fit-content' }}
                                disabled={isLoading}
                                loading={isLoading}
                            >
                                Login
                            </PrimaryButton>
                        </Grid>

                        <Grid item xs={12}>
                            <Link
                                to="/signin/change/password/verify"
                                style={{ fontFamily: 'Outfit', textDecoration: 'underline', color: Colors.darkNavy }}
                            >
                                Forgot password?
                            </Link>
                        </Grid>
                    </Content>
                </form>
            </FormContainer>
        </SignUpLoginContainer>
    );
}

const FormContainer = styled(Grid)({
    padding: 40,
    overflowY: 'auto',
    maxHeight: '100%',
});

const Content = styled(Grid)({
    padding: '12%',
    [theme.breakpoints.down('md')]: {
        padding: '3%',
    },
    paddingTop: '5%',
});
